<h4 mat-dialog-title *ngIf="!is_not_modal" class="mb-0">
  <div class="dialog-title">
    <span class="line-1">
      {{all_files[index].displayname || all_files[index].filename ||all_files[index].fileName }}
    </span>
    <!-- [attr.href]="all_files[index] && all_files[index].content ? ((all_files[index].content) | SafeFilePipe):(all_files[index][serverPathname]&& all_files[index][serverPathname]!='' ?storage_url+ all_files[index][serverPathname] : '')"
      [attr.download]="all_files[index][serverFilename]" -->
    <a class="btn btn-sm btn-default mx-2" (click)="downloadFile(all_files[index])" matTooltip="Download"
      target='_self'>
      Download <i class="mx-1 fa fa-download" aria-hidden="true"></i>
    </a>
    <span class="ml-auto">
      <span class=" mr-4" *ngIf="all_files.length > 1">
        <i class="fa fa-angle-double-left prev-icon pointer" matTooltip="Previous"
          [ngClass]="{'out-of-index' : negative_index }" (click)="previousFile()" *ngIf="index != 0">
        </i>
        <span class="count mx-2"> {{(index + 1) +( ' of ' | translate) + (all_files.length)}}</span>
        <i class="fa fa-angle-double-right next-icon pointer" matTooltip=" Next"
          [ngClass]="{'out-of-bound' : index_outof_bound }" (click)="nextFile()" *ngIf="index != all_files.length -1 ">
        </i>
      </span>
      <span (click)="close()" style="cursor:pointer" *ngIf="!is_not_modal">
        <i class="fa fa-times" aria-hidden="true"></i>
      </span>
    </span>


  </div>

</h4>

<h4 *ngIf="is_not_modal" class="mb-0">
  <div class="dialog-title">
    <span class="line-1">
      {{all_files[index].displayname || all_files[index].filename ||all_files[index].fileName }}
    </span>
    <!-- [attr.href]="all_files[index] && all_files[index].content ? ((all_files[index].content) | SafeFilePipe):(all_files[index][serverPathname]&& all_files[index][serverPathname]!='' ?storage_url+ all_files[index][serverPathname] : '')"
      [attr.download]="all_files[index][serverFilename]" -->
    <a class="btn btn-sm btn-default mx-2" (click)="downloadFile(all_files[index])" matTooltip="Download"
      target='_self'>
      Download <i class="mx-1 fa fa-download" aria-hidden="true"></i>
    </a>
    <span class="ml-auto">
      <span class=" mr-4" *ngIf="all_files.length > 1">
        <i class="fa fa-angle-double-left prev-icon pointer" matTooltip="Previous"
          [ngClass]="{'out-of-index' : negative_index }" (click)="previousFile()" *ngIf="index != 0">
        </i>
        <span class="count mx-2"> {{(index + 1) +( ' of ' | translate) + (all_files.length)}}</span>
        <i class="fa fa-angle-double-right next-icon pointer" matTooltip=" Next"
          [ngClass]="{'out-of-bound' : index_outof_bound }" (click)="nextFile()" *ngIf="index != all_files.length -1 ">
        </i>
      </span>
      <span (click)="close()" style="cursor:pointer" *ngIf="!is_not_modal">
        <i class="fa fa-times" aria-hidden="true"></i>
      </span>
    </span>


  </div>

</h4>

<div [ngClass]="other_data && (other_data.cr_user_id ||other_data.lu_user_id ||  other_data.notes) ?'h-75':'height'"
  *ngIf="reset_all_files_flag">
  <ng-container *ngIf="all_files[index] && (all_files[index][serverPathname]); else image">
    <div class="" style="height: 100%;" *ngIf=" (all_files[index].is_doc || all_files[index].is_pdf) else image;">
      <!-- <app-ngx-dov-viewer viewer="google" [cdnPath]="( all_files[index].url)" [google_container_url_document]="''"
        style="width: 100%;height: 100%;object-fit: contain;">
      </app-ngx-dov-viewer> -->
      <object *ngIf="all_files[index].file_data ;else urls " id="resumeViewer" frameborder="0"
        style="width: 100%;height: 100%;object-fit: contain;"
        [data]="all_files[index].file_data | safeHTMLPipe : 'resourceUrl'" [title]="all_files[index].filename">
      </object>
      <ng-template #urls>
        <app-ngx-dov-viewer viewer="google" *ngIf="!fetching_data &&all_files[index].url "
          [cdnPath]="( all_files[index].url)" [google_container_url_document]="''"
          style="width: 100%;height: 100%;object-fit: contain;">
        </app-ngx-dov-viewer>
      </ng-template>

      <!-- <object id="resumeViewer" *ngIf="all_files[index].is_pdf" frameborder="0"
        style="width: 100%;height: 100%;object-fit: contain;"
        [data]="(google_container_url_document + all_files[index][serverPathname] + '&embedded=true') | SafeFilePipe"
        [title]="all_files[index].filename">
      </object>
      <object *ngIf="all_files[index].file_data && all_files[index].is_doc" id="resumeViewer" frameborder="0"
        style="width: 100%;height: 100%;object-fit: contain;" [data]="all_files[index].file_data | SafeFilePipe"
        [title]="all_files[index].filename">
      </object> -->
    </div>
  </ng-container>
  <ng-template #image>
    <div style="height: 100%;" *ngIf="reset_object_tag && all_files[index].is_image; else elseTemplate;">

      <img id="resumeViewer" frameborder="0" *ngIf="!all_files[index].content &&all_files[index]['url'] "
        style="width: 100%;height: 100%;object-fit: contain;" [src]="(  all_files[index]['url']) | SafeFilePipe"
        [title]="all_files[index][serverFilename]">
      <img id="resumeViewer" frameborder="0" *ngIf="all_files[index].content"
        style="width: 100%;height: 100%;object-fit: contain;" [src]="all_files[index].content | SafeFilePipe"
        [title]="all_files[index].filename">

    </div>
  </ng-template>
  <ng-template #elseTemplate>
    <ng-container
      *ngIf="(all_files[index].is_pdf || all_files[index].is_image) && !all_files[index][serverPathname] ;else filedata">
      <div class="" style="height: 100%;" *ngIf="reset_embed_tag">
        <embed id="resumeViewer" frameborder="0" *ngIf="!all_files[index][serverPathname]"
          style="width: 100%;height: 100%;object-fit: contain;" [src]="all_files[index].content | SafeFilePipe"
          [type]="all_files[index].mime_type" [title]="all_files[index].filename">
        <!-- <object id="resumeViewer" frameborder="0" *ngIf="all_files[index].cdnpath && all_files[index].file_data"
          style="width: 100%;height: 100%;object-fit: contain;" [data]="all_files[index].file_data" [title]="all_files[index].filename">
        </object> -->
      </div>
    </ng-container>

  </ng-template>
  <ng-template #filedata>
    <ng-container
      *ngIf="(all_files[index].is_pdf || all_files[index].is_image) &&all_files[index][serverPathname] ;else content">
      <div class="" style="height: 100%;" *ngIf="all_files[index].file_data">
        <object #document id="document" *ngIf="all_files[index].file_data"
          [data]="all_files[index].file_data | SafeFilePipe" style="width: 100%;height: calc(100vh - 175px);"
          [title]="data && data.firstName">
        </object>
        <!-- <object id="resumeViewer" frameborder="0" *ngIf="all_files[index].cdnpath && all_files[index].file_data"
          style="width: 100%;height: 100%;object-fit: contain;" [data]="all_files[index].file_data" [title]="all_files[index].filename">
        </object> -->
      </div>
    </ng-container>

  </ng-template>
  <ng-template #content>
    <ng-container
      *ngIf="( all_files[index].content &&all_files[index].content !='' && !all_files[index].file_data ) &&!all_files[index][serverPathname] &&!all_files[index].is_xlsx  ;else xlsx">
      <div class="" style="height: 100%;">
        <object #document id="document" [data]="all_files[index].content | SafeFilePipe"
          style="width: 100%;height: calc(100vh - 175px);" [title]="data && data[serverFilename]">
        </object>
        <!-- <object id="resumeViewer" frameborder="0" *ngIf="all_files[index].cdnpath && all_files[index].file_data"
          style="width: 100%;height: 100%;object-fit: contain;" [data]="all_files[index].file_data" [title]="all_files[index].filename">
        </object> -->
      </div>
    </ng-container>

  </ng-template>
  <ng-template #xlsx>
    <div class="table-responsive tm-data-table pt-2" style="height: 100%;"
      *ngIf="all_files[index].is_xlsx;else noPreview ">
      <table class="table table-striped table-bordered" *ngIf="all_files[index].data;else severXLX">
        <tbody>
          <tr *ngFor="let row of all_files[index].data;let i = index">
            <td> {{i+1}} </td>
            <td *ngFor="let val of row">
              {{val}}
            </td>
          </tr>
        </tbody>
      </table>
      <ng-template #severXLX>
        <app-ngx-dov-viewer viewer="google" [cdnPath]="all_files[index][serverPathname]" [enable_signed_url]="1"
          [google_container_url_document]="''" style="width: 100%;height: 100%;object-fit: contain;">
        </app-ngx-dov-viewer>
      </ng-template>

    </div>
  </ng-template>
  <ng-template #noPreview>
    <div class="d-block text-center p-5">
      {{'FILES.no_preview' | translate}}
    </div>
  </ng-template>
  <!-- <button (click)="close()" class=" m-1 btn js-btn-cancel btn-sm"> {{'Cancel' |translate}} </button> -->
</div>